'use client'

import { CheckCircle2, Eye, EyeOff, XCircle } from 'lucide-react'
import { motion } from 'motion/react'

import { talentPoolCopy } from '@/app/talent-pool/copy'

export function TalentPoolRecruiterSection() {
  const copy = talentPoolCopy

  return (
    <section className="pb-14">
      <div className="rounded-3xl border border-border-primary bg-white dark:bg-card px-5 py-10 sm:px-8">
        <div className="mx-auto flex w-full max-w-[664px] flex-col items-center gap-4 text-center">
          <div className="rounded-full border-[1.5px] border-surface-primary bg-white dark:bg-card px-3 py-2 text-sm text-text-body">
            Dashboard Preview
          </div>
          <h2 className="text-[32px] font-medium leading-[40px] tracking-[-0.02em] text-text-heading md:text-[48px] md:leading-[60px] md:tracking-[-0.04em]">
            {copy.landing.recruiter.title}
          </h2>
          <p className="max-w-[478px] text-base leading-[26px] text-text-muted md:text-[20px] md:leading-[30px]">
            {copy.landing.recruiter.description}
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6">
          {/* Can See Card */}
          <motion.article
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5 }}
            className="rounded-2xl border border-border-primary bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-950/20 dark:to-emerald-950/20 p-6"
          >
            <div className="mb-5 inline-flex items-center gap-2 rounded-lg bg-green-100 dark:bg-green-900/30 px-3 py-1.5">
              <Eye className="h-4 w-4 text-green-700 dark:text-green-400" />
              <span className="text-xs font-semibold uppercase tracking-wider text-green-700 dark:text-green-400">
                {copy.landing.recruiter.canSeeTitle}
              </span>
            </div>
            <ul className="space-y-3">
              {copy.landing.recruiter.canSee.map((item, index) => (
                <motion.li
                  key={item}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 + index * 0.1 }}
                  className="flex items-start gap-3 text-[15px] leading-[24px] text-text-heading md:text-[16px] md:leading-[26px]"
                >
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-green-600 dark:text-green-500" />
                  <span>{item}</span>
                </motion.li>
              ))}
            </ul>
          </motion.article>

          {/* Cannot See Card */}
          <motion.article
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="rounded-2xl border border-border-primary bg-gradient-to-br from-red-50 to-orange-50 dark:from-red-950/20 dark:to-orange-950/20 p-6"
          >
            <div className="mb-5 inline-flex items-center gap-2 rounded-lg bg-red-100 dark:bg-red-900/30 px-3 py-1.5">
              <EyeOff className="h-4 w-4 text-red-700 dark:text-red-400" />
              <span className="text-xs font-semibold uppercase tracking-wider text-red-700 dark:text-red-400">
                {copy.landing.recruiter.canNotSeeTitle}
              </span>
            </div>
            <ul className="space-y-3">
              {copy.landing.recruiter.canNotSee.map((item, index) => (
                <motion.li
                  key={item}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                  className="flex items-start gap-3 text-[15px] leading-[24px] text-text-heading md:text-[16px] md:leading-[26px]"
                >
                  <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-600 dark:text-red-500" />
                  <span>{item}</span>
                </motion.li>
              ))}
            </ul>
          </motion.article>
        </div>
      </div>
    </section>
  )
}
